// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Professional Enterprise Admin Dashboard - Legal Education Platform */

/* Subtle Professional Animations */
@keyframes slideInDown {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes slideInUp {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes slideInLeft {
    0% {
      opacity: 0;
      transform: translateX(-20px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  @keyframes subtlePulse {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    }
    50% {
      transform: scale(1.01);
      box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);
    }
  }
  
  @keyframes progressBar {
    0% { width: 0%; }
    100% { width: 100%; }
  }
  
  @keyframes rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  /* Base Professional Styles */
  .admin-dashboard-container {
    min-height: 100vh;
    background: #f8fafc;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    color: #1e293b;
    line-height: 1.6;
  }
  
  /* Subtle Background Pattern */
  .admin-dashboard-container::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      radial-gradient(circle at 25px 25px, rgba(15, 23, 42, 0.02) 2px, transparent 0),
      radial-gradient(circle at 75px 75px, rgba(15, 23, 42, 0.02) 2px, transparent 0);
    background-size: 50px 50px;
    pointer-events: none;
    z-index: 0;
  }
  
  /* Professional Header */
  .admin-header {
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    position: sticky;
  

  }
  
  .admin-header-content {
    max-width: 1440px;
    margin: 0 auto;
    padding: 16px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  
  .admin-logo-section {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .admin-logo {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
    border: 2px solid #e2e8f0;
    transition: all 0.2s ease;
  }
  
  .admin-logo:hover {
    border-color: #22c55e;
    transform: scale(1.05);
  }
  
  .admin-title-section h1 {
    font-size: 20px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
    letter-spacing: -0.025em;
  }
  
  .admin-title-section p {
    font-size: 14px;
    color: #64748b;
    margin: 2px 0 0 0;
    font-weight: 500;
  }
  
  .admin-user-section {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .admin-user-info {
    text-align: right;
    padding: 8px 0;
  }
  
  .admin-user-name {
    font-size: 14px;
    font-weight: 600;
    color: #0f172a;
    margin: 0 0 2px 0;
  }
  
  .admin-user-role {
    font-size: 12px;
    color: #64748b;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .admin-logout-btn {
    background: #f8fafc;
    color: #64748b;
    border: 1px solid #e2e8f0;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .admin-logout-btn:hover {
    background: #20c92e;
    color: white;
    border-color: #2abd14;
    transform: translateY(-1px);
  }
  
  /* Main Content Container */
  .admin-main-content {
    max-width: 1440px;
    margin: 0 auto;
    padding: 24px;
    animation: fadeIn 0.6s ease-out 0.2s both;
  }
  
  /* Professional Navigation */
  .admin-nav-container {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 6px;
    margin-bottom: 32px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  .admin-nav-tabs {
    display: flex;
    gap: 4px;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .admin-nav-tabs::-webkit-scrollbar {
    display: none;
  }
  
  .admin-nav-tab {
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    padding: 10px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #64748b;
    white-space: nowrap;
    position: relative;
  }
  
  .admin-nav-tab.active {
    background: #0f172a;
    color: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  
  .admin-nav-tab:not(.active):hover {
    background: #f1f5f9;
    color: #0f172a;
  }
  
  .admin-nav-tab-icon {
    font-size: 16px;
  }
  
  /* Professional Stats Grid */
  .admin-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 24px;
    margin-bottom: 32px;
  }
  
  .admin-stat-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 24px;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;
  }
  
  .admin-stat-card:hover {
    border-color: #22c55e;
    box-shadow: 0 4px 20px rgba(34, 197, 94, 0.08);
    transform: translateY(-2px);
  }
  
  .admin-stat-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #22c55e, #10b981);
  }
  
  .admin-stat-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  
  .admin-stat-content {
    flex: 1 1;
  }
  
  .admin-stat-label {
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .admin-stat-number {
    font-size: 32px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1;
    margin-bottom: 4px;
  }
  
  .admin-stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
  }
  
  .admin-stat-icon.users { background: linear-gradient(135deg, #3b82f6, #2563eb); }
  .admin-stat-icon.courses { background: linear-gradient(135deg, #22c55e, #16a34a); }
  .admin-stat-icon.videos { background: linear-gradient(135deg, #8b5cf6, #7c3aed); }
  .admin-stat-icon.blog { background: linear-gradient(135deg, #f59e0b, #d97706); }
  .admin-stat-icon.pending { background: linear-gradient(135deg, #ef4444, #dc2626); }
  .admin-stat-icon.subjects { background: linear-gradient(135deg, #06b6d4, #0891b2); }
  
  .admin-stat-trend {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #22c55e;
    font-weight: 500;
    margin-top: 8px;
  }
  
  .admin-stat-trend.negative {
    color: #ef4444;
  }
  
  .admin-stat-trend.neutral {
    color: #64748b;
  }
  
  /* Professional Content Sections */
  .admin-content-section {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    animation: slideInUp 0.6s ease-out;
  }
  
  .admin-section-header {
    padding: 24px 24px 0 24px;
    border-bottom: 1px solid #f1f5f9;
    margin-bottom: 0;
  }
  
  .admin-section-title {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 8px 0;
    letter-spacing: -0.025em;
  }
  
  .admin-section-subtitle {
    font-size: 14px;
    color: #64748b;
    margin: 0 0 24px 0;
    line-height: 1.5;
  }
  
  .admin-section-content {
    padding: 24px;
  }
  
  /* Dashboard Overview Cards */
  .admin-overview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 24px;
    margin-top: 24px;
  }
  
  .admin-overview-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 24px;
    transition: all 0.2s ease;
  }
  
  .admin-overview-card:hover {
    border-color: #22c55e;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
  
  .admin-overview-title {
    font-size: 16px;
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .admin-overview-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .admin-overview-item {
    padding: 12px 0;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }
  
  .admin-overview-item:last-child {
    border-bottom: none;
  }
  
  .admin-overview-item-label {
    color: #0f172a;
    font-weight: 500;
  }
  
  .admin-overview-item-value {
    color: #64748b;
    font-weight: 600;
  }
  
  /* Quick Actions */
  .admin-quick-actions {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
    flex-wrap: wrap;
  }
  
  .admin-quick-action {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #0f172a;
    padding: 10px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
  }
  
  .admin-quick-action:hover {
    background: #22c55e;
    color: white;
    border-color: #22c55e;
    transform: translateY(-1px);
  }
  
  .admin-quick-action.primary {
    background: #22c55e;
    color: white;
    border-color: #22c55e;
  }
  
  .admin-quick-action.primary:hover {
    background: #16a34a;
    border-color: #16a34a;
  }
  
  /* Professional Loading State */
  .admin-loading {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
  }
  
  .admin-loading-content {
    text-align: center;
    padding: 40px;
  }
  
  .admin-loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f1f5f9;
    border-left: 3px solid #22c55e;
    border-radius: 50%;
    animation: rotate 1s linear infinite;
    margin: 0 auto 16px;
  }
  
  .admin-loading-text {
    font-size: 16px;
    color: #64748b;
    font-weight: 500;
  }
  
  /* Activity Timeline */
  .admin-activity-timeline {
    position: relative;
  }
  
  .admin-activity-item {
    display: flex;
    gap: 16px;
    padding: 16px 0;
    border-bottom: 1px solid #f1f5f9;
  }
  
  .admin-activity-item:last-child {
    border-bottom: none;
  }
  
  .admin-activity-icon {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
    background: #f1f5f9;
  }
  
  .admin-activity-content {
    flex: 1 1;
  }
  
  .admin-activity-title {
    font-size: 14px;
    font-weight: 500;
    color: #0f172a;
    margin-bottom: 4px;
  }
  
  .admin-activity-description {
    font-size: 13px;
    color: #64748b;
    margin-bottom: 4px;
  }
  
  .admin-activity-time {
    font-size: 12px;
    color: #94a3b8;
  }
  
  /* Status Badges */
  .admin-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .admin-status-badge.success {
    background: #dcfce7;
    color: #166534;
  }
  
  .admin-status-badge.warning {
    background: #fef3c7;
    color: #92400e;
  }
  
  .admin-status-badge.error {
    background: #fee2e2;
    color: #991b1b;
  }
  
  .admin-status-badge.info {
    background: #dbeafe;
    color: #1e40af;
  }
  
  /* Data Tables */
  .admin-table-container {
    overflow-x: auto;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
  }
  
  .admin-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
  }
  
  .admin-table th {
    background: #f8fafc;
    padding: 12px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid #e2e8f0;
  }
  
  .admin-table td {
    padding: 16px;
    border-bottom: 1px solid #f1f5f9;
    font-size: 14px;
    color: #0f172a;
  }
  
  .admin-table tr:last-child td {
    border-bottom: none;
  }
  
  .admin-table tr:hover {
    background: #f8fafc;
  }
  
  /* Responsive Design */
  @media (max-width: 1024px) {
    .admin-main-content {
      padding: 20px;
    }
    
    .admin-header-content {
      padding: 12px 20px;
    }
    
    .admin-stats-grid {
      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
      gap: 20px;
    }
  }
  
  @media (max-width: 768px) {
    .admin-main-content {
      padding: 16px;
    }
    
    .admin-header-content {
      flex-direction: column;
      gap: 16px;
      padding: 16px;
    }
    
    .admin-logo-section {
      order: 1;
    }
    
    .admin-user-section {
      order: 2;
      width: 100%;
      justify-content: space-between;
    }
    
    .admin-nav-tabs {
      flex-direction: column;
      gap: 4px;
    }
    
    .admin-nav-tab {
      justify-content: flex-start;
      padding: 12px 16px;
    }
    
    .admin-stats-grid {
      grid-template-columns: 1fr;
      gap: 16px;
    }
    
    .admin-stat-card {
      padding: 20px;
    }
    
    .admin-section-content {
      padding: 20px;
    }
    
    .admin-quick-actions {
      flex-direction: column;
    }
    
    .admin-quick-action {
      justify-content: center;
    }
  }
  
  @media (max-width: 480px) {
    .admin-main-content {
      padding: 12px;
    }
    
    .admin-header-content {
      padding: 12px;
    }
    
    .admin-stat-number {
      font-size: 28px;
    }
    
    .admin-section-content {
      padding: 16px;
    }
    
    .admin-overview-grid {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
  
  /* Print Styles */
  @media print {
    .admin-dashboard-container::before,
    .admin-nav-container,
    .admin-logout-btn,
    .admin-quick-actions {
      display: none;
    }
    
    .admin-dashboard-container {
      background: white;
    }
    
    * {
      animation: none !important;
      transition: none !important;
    }
    
    .admin-stat-card,
    .admin-content-section,
    .admin-overview-card {
      page-break-inside: avoid;
      break-inside: avoid;
      box-shadow: none;
      border: 1px solid #e2e8f0;
    }
  }
  
  /* Custom Scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
  
  /* Selection */
  ::selection {
    background: rgba(34, 197, 94, 0.2);
    color: #0f172a;
  }
  
  /* Focus Styles */
  .admin-nav-tab:focus,
  .admin-logout-btn:focus,
  .admin-quick-action:focus {
    outline: 2px solid #22c55e;
    outline-offset: 2px;
  }`, "",{"version":3,"sources":["webpack://./src/styles/AdminDashboard.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE,mCAAmC;AACnC;IACI;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,mBAAmB;MACnB,0CAA0C;IAC5C;IACA;MACE,sBAAsB;MACtB,0CAA0C;IAC5C;EACF;;EAEA;IACE,KAAK,SAAS,EAAE;IAChB,OAAO,WAAW,EAAE;EACtB;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;IACjB,mBAAmB;IACnB,uGAAuG;IACvG,cAAc;IACd,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;qFAEiF;IACjF,0BAA0B;IAC1B,oBAAoB;IACpB,UAAU;EACZ;;EAEA,wBAAwB;EACxB;IACE,mBAAmB;IACnB,gCAAgC;IAChC,yCAAyC;IACzC,gBAAgB;;;EAGlB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;EAErB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,SAAS;IACT,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA,2BAA2B;EAC3B;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,yCAAyC;EAC3C;;EAEA,4BAA4B;EAC5B;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;EAC1C;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,oDAAoD;EACtD;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;EAChB;;EAEA,yBAAyB,qDAAqD,EAAE;EAChF,2BAA2B,qDAAqD,EAAE;EAClF,0BAA0B,qDAAqD,EAAE;EACjF,wBAAwB,qDAAqD,EAAE;EAC/E,2BAA2B,qDAAqD,EAAE;EAClF,4BAA4B,qDAAqD,EAAE;;EAEnF;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,kCAAkC;EAClC;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,+BAA+B;EAC/B;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,2DAA2D;MAC3D,SAAS;IACX;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;MACtB,SAAS;MACT,aAAa;IACf;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,QAAQ;MACR,WAAW;MACX,8BAA8B;IAChC;;IAEA;MACE,sBAAsB;MACtB,QAAQ;IACV;;IAEA;MACE,2BAA2B;MAC3B,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;MAC1B,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,0BAA0B;MAC1B,SAAS;IACX;EACF;;EAEA,iBAAiB;EACjB;IACE;;;;MAIE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,0BAA0B;MAC1B,2BAA2B;IAC7B;;IAEA;;;MAGE,wBAAmB;MAAnB,mBAAmB;MACnB,gBAAgB;MAChB,yBAAyB;IAC3B;EACF;;EAEA,qBAAqB;EACrB;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,cAAc;EACd;IACE,kCAAkC;IAClC,cAAc;EAChB;;EAEA,iBAAiB;EACjB;;;IAGE,0BAA0B;IAC1B,mBAAmB;EACrB","sourcesContent":["/* Professional Enterprise Admin Dashboard - Legal Education Platform */\n\n/* Subtle Professional Animations */\n@keyframes slideInDown {\n    0% {\n      opacity: 0;\n      transform: translateY(-20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes slideInUp {\n    0% {\n      opacity: 0;\n      transform: translateY(20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  @keyframes slideInLeft {\n    0% {\n      opacity: 0;\n      transform: translateX(-20px);\n    }\n    100% {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n  \n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  \n  @keyframes subtlePulse {\n    0%, 100% {\n      transform: scale(1);\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    }\n    50% {\n      transform: scale(1.01);\n      box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);\n    }\n  }\n  \n  @keyframes progressBar {\n    0% { width: 0%; }\n    100% { width: 100%; }\n  }\n  \n  @keyframes rotate {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n  /* Base Professional Styles */\n  .admin-dashboard-container {\n    min-height: 100vh;\n    background: #f8fafc;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n    color: #1e293b;\n    line-height: 1.6;\n  }\n  \n  /* Subtle Background Pattern */\n  .admin-dashboard-container::before {\n    content: '';\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: \n      radial-gradient(circle at 25px 25px, rgba(15, 23, 42, 0.02) 2px, transparent 0),\n      radial-gradient(circle at 75px 75px, rgba(15, 23, 42, 0.02) 2px, transparent 0);\n    background-size: 50px 50px;\n    pointer-events: none;\n    z-index: 0;\n  }\n  \n  /* Professional Header */\n  .admin-header {\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n    position: sticky;\n  \n\n  }\n  \n  .admin-header-content {\n    max-width: 1440px;\n    margin: 0 auto;\n    padding: 16px 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n  }\n  \n  .admin-logo-section {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  \n  .admin-logo {\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    object-fit: cover;\n    border: 2px solid #e2e8f0;\n    transition: all 0.2s ease;\n  }\n  \n  .admin-logo:hover {\n    border-color: #22c55e;\n    transform: scale(1.05);\n  }\n  \n  .admin-title-section h1 {\n    font-size: 20px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0;\n    letter-spacing: -0.025em;\n  }\n  \n  .admin-title-section p {\n    font-size: 14px;\n    color: #64748b;\n    margin: 2px 0 0 0;\n    font-weight: 500;\n  }\n  \n  .admin-user-section {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  \n  .admin-user-info {\n    text-align: right;\n    padding: 8px 0;\n  }\n  \n  .admin-user-name {\n    font-size: 14px;\n    font-weight: 600;\n    color: #0f172a;\n    margin: 0 0 2px 0;\n  }\n  \n  .admin-user-role {\n    font-size: 12px;\n    color: #64748b;\n    margin: 0;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  \n  .admin-logout-btn {\n    background: #f8fafc;\n    color: #64748b;\n    border: 1px solid #e2e8f0;\n    padding: 8px 16px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .admin-logout-btn:hover {\n    background: #20c92e;\n    color: white;\n    border-color: #2abd14;\n    transform: translateY(-1px);\n  }\n  \n  /* Main Content Container */\n  .admin-main-content {\n    max-width: 1440px;\n    margin: 0 auto;\n    padding: 24px;\n    animation: fadeIn 0.6s ease-out 0.2s both;\n  }\n  \n  /* Professional Navigation */\n  .admin-nav-container {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 6px;\n    margin-bottom: 32px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  }\n  \n  .admin-nav-tabs {\n    display: flex;\n    gap: 4px;\n    overflow-x: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  \n  .admin-nav-tabs::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .admin-nav-tab {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: transparent;\n    border: none;\n    padding: 10px 16px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    color: #64748b;\n    white-space: nowrap;\n    position: relative;\n  }\n  \n  .admin-nav-tab.active {\n    background: #0f172a;\n    color: white;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  }\n  \n  .admin-nav-tab:not(.active):hover {\n    background: #f1f5f9;\n    color: #0f172a;\n  }\n  \n  .admin-nav-tab-icon {\n    font-size: 16px;\n  }\n  \n  /* Professional Stats Grid */\n  .admin-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 24px;\n    margin-bottom: 32px;\n  }\n  \n  .admin-stat-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 24px;\n    transition: all 0.2s ease;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .admin-stat-card:hover {\n    border-color: #22c55e;\n    box-shadow: 0 4px 20px rgba(34, 197, 94, 0.08);\n    transform: translateY(-2px);\n  }\n  \n  .admin-stat-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background: linear-gradient(90deg, #22c55e, #10b981);\n  }\n  \n  .admin-stat-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 16px;\n  }\n  \n  .admin-stat-content {\n    flex: 1;\n  }\n  \n  .admin-stat-label {\n    font-size: 14px;\n    color: #64748b;\n    font-weight: 500;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  \n  .admin-stat-number {\n    font-size: 32px;\n    font-weight: 700;\n    color: #0f172a;\n    line-height: 1;\n    margin-bottom: 4px;\n  }\n  \n  .admin-stat-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    flex-shrink: 0;\n  }\n  \n  .admin-stat-icon.users { background: linear-gradient(135deg, #3b82f6, #2563eb); }\n  .admin-stat-icon.courses { background: linear-gradient(135deg, #22c55e, #16a34a); }\n  .admin-stat-icon.videos { background: linear-gradient(135deg, #8b5cf6, #7c3aed); }\n  .admin-stat-icon.blog { background: linear-gradient(135deg, #f59e0b, #d97706); }\n  .admin-stat-icon.pending { background: linear-gradient(135deg, #ef4444, #dc2626); }\n  .admin-stat-icon.subjects { background: linear-gradient(135deg, #06b6d4, #0891b2); }\n  \n  .admin-stat-trend {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: #22c55e;\n    font-weight: 500;\n    margin-top: 8px;\n  }\n  \n  .admin-stat-trend.negative {\n    color: #ef4444;\n  }\n  \n  .admin-stat-trend.neutral {\n    color: #64748b;\n  }\n  \n  /* Professional Content Sections */\n  .admin-content-section {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n    animation: slideInUp 0.6s ease-out;\n  }\n  \n  .admin-section-header {\n    padding: 24px 24px 0 24px;\n    border-bottom: 1px solid #f1f5f9;\n    margin-bottom: 0;\n  }\n  \n  .admin-section-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0 0 8px 0;\n    letter-spacing: -0.025em;\n  }\n  \n  .admin-section-subtitle {\n    font-size: 14px;\n    color: #64748b;\n    margin: 0 0 24px 0;\n    line-height: 1.5;\n  }\n  \n  .admin-section-content {\n    padding: 24px;\n  }\n  \n  /* Dashboard Overview Cards */\n  .admin-overview-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 24px;\n    margin-top: 24px;\n  }\n  \n  .admin-overview-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 24px;\n    transition: all 0.2s ease;\n  }\n  \n  .admin-overview-card:hover {\n    border-color: #22c55e;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  }\n  \n  .admin-overview-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: #0f172a;\n    margin-bottom: 16px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .admin-overview-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .admin-overview-item {\n    padding: 12px 0;\n    border-bottom: 1px solid #f1f5f9;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 14px;\n  }\n  \n  .admin-overview-item:last-child {\n    border-bottom: none;\n  }\n  \n  .admin-overview-item-label {\n    color: #0f172a;\n    font-weight: 500;\n  }\n  \n  .admin-overview-item-value {\n    color: #64748b;\n    font-weight: 600;\n  }\n  \n  /* Quick Actions */\n  .admin-quick-actions {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n  }\n  \n  .admin-quick-action {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    color: #0f172a;\n    padding: 10px 16px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    text-decoration: none;\n  }\n  \n  .admin-quick-action:hover {\n    background: #22c55e;\n    color: white;\n    border-color: #22c55e;\n    transform: translateY(-1px);\n  }\n  \n  .admin-quick-action.primary {\n    background: #22c55e;\n    color: white;\n    border-color: #22c55e;\n  }\n  \n  .admin-quick-action.primary:hover {\n    background: #16a34a;\n    border-color: #16a34a;\n  }\n  \n  /* Professional Loading State */\n  .admin-loading {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f8fafc;\n  }\n  \n  .admin-loading-content {\n    text-align: center;\n    padding: 40px;\n  }\n  \n  .admin-loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #f1f5f9;\n    border-left: 3px solid #22c55e;\n    border-radius: 50%;\n    animation: rotate 1s linear infinite;\n    margin: 0 auto 16px;\n  }\n  \n  .admin-loading-text {\n    font-size: 16px;\n    color: #64748b;\n    font-weight: 500;\n  }\n  \n  /* Activity Timeline */\n  .admin-activity-timeline {\n    position: relative;\n  }\n  \n  .admin-activity-item {\n    display: flex;\n    gap: 16px;\n    padding: 16px 0;\n    border-bottom: 1px solid #f1f5f9;\n  }\n  \n  .admin-activity-item:last-child {\n    border-bottom: none;\n  }\n  \n  .admin-activity-icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    flex-shrink: 0;\n    background: #f1f5f9;\n  }\n  \n  .admin-activity-content {\n    flex: 1;\n  }\n  \n  .admin-activity-title {\n    font-size: 14px;\n    font-weight: 500;\n    color: #0f172a;\n    margin-bottom: 4px;\n  }\n  \n  .admin-activity-description {\n    font-size: 13px;\n    color: #64748b;\n    margin-bottom: 4px;\n  }\n  \n  .admin-activity-time {\n    font-size: 12px;\n    color: #94a3b8;\n  }\n  \n  /* Status Badges */\n  .admin-status-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 8px;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  \n  .admin-status-badge.success {\n    background: #dcfce7;\n    color: #166534;\n  }\n  \n  .admin-status-badge.warning {\n    background: #fef3c7;\n    color: #92400e;\n  }\n  \n  .admin-status-badge.error {\n    background: #fee2e2;\n    color: #991b1b;\n  }\n  \n  .admin-status-badge.info {\n    background: #dbeafe;\n    color: #1e40af;\n  }\n  \n  /* Data Tables */\n  .admin-table-container {\n    overflow-x: auto;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n  }\n  \n  .admin-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: white;\n  }\n  \n  .admin-table th {\n    background: #f8fafc;\n    padding: 12px 16px;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475569;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border-bottom: 1px solid #e2e8f0;\n  }\n  \n  .admin-table td {\n    padding: 16px;\n    border-bottom: 1px solid #f1f5f9;\n    font-size: 14px;\n    color: #0f172a;\n  }\n  \n  .admin-table tr:last-child td {\n    border-bottom: none;\n  }\n  \n  .admin-table tr:hover {\n    background: #f8fafc;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 1024px) {\n    .admin-main-content {\n      padding: 20px;\n    }\n    \n    .admin-header-content {\n      padding: 12px 20px;\n    }\n    \n    .admin-stats-grid {\n      grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n      gap: 20px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .admin-main-content {\n      padding: 16px;\n    }\n    \n    .admin-header-content {\n      flex-direction: column;\n      gap: 16px;\n      padding: 16px;\n    }\n    \n    .admin-logo-section {\n      order: 1;\n    }\n    \n    .admin-user-section {\n      order: 2;\n      width: 100%;\n      justify-content: space-between;\n    }\n    \n    .admin-nav-tabs {\n      flex-direction: column;\n      gap: 4px;\n    }\n    \n    .admin-nav-tab {\n      justify-content: flex-start;\n      padding: 12px 16px;\n    }\n    \n    .admin-stats-grid {\n      grid-template-columns: 1fr;\n      gap: 16px;\n    }\n    \n    .admin-stat-card {\n      padding: 20px;\n    }\n    \n    .admin-section-content {\n      padding: 20px;\n    }\n    \n    .admin-quick-actions {\n      flex-direction: column;\n    }\n    \n    .admin-quick-action {\n      justify-content: center;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .admin-main-content {\n      padding: 12px;\n    }\n    \n    .admin-header-content {\n      padding: 12px;\n    }\n    \n    .admin-stat-number {\n      font-size: 28px;\n    }\n    \n    .admin-section-content {\n      padding: 16px;\n    }\n    \n    .admin-overview-grid {\n      grid-template-columns: 1fr;\n      gap: 16px;\n    }\n  }\n  \n  /* Print Styles */\n  @media print {\n    .admin-dashboard-container::before,\n    .admin-nav-container,\n    .admin-logout-btn,\n    .admin-quick-actions {\n      display: none;\n    }\n    \n    .admin-dashboard-container {\n      background: white;\n    }\n    \n    * {\n      animation: none !important;\n      transition: none !important;\n    }\n    \n    .admin-stat-card,\n    .admin-content-section,\n    .admin-overview-card {\n      break-inside: avoid;\n      box-shadow: none;\n      border: 1px solid #e2e8f0;\n    }\n  }\n  \n  /* Custom Scrollbar */\n  ::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n  \n  ::-webkit-scrollbar-track {\n    background: #f1f5f9;\n    border-radius: 3px;\n  }\n  \n  ::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 3px;\n  }\n  \n  ::-webkit-scrollbar-thumb:hover {\n    background: #94a3b8;\n  }\n  \n  /* Selection */\n  ::selection {\n    background: rgba(34, 197, 94, 0.2);\n    color: #0f172a;\n  }\n  \n  /* Focus Styles */\n  .admin-nav-tab:focus,\n  .admin-logout-btn:focus,\n  .admin-quick-action:focus {\n    outline: 2px solid #22c55e;\n    outline-offset: 2px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
